import { render, staticRenderFns } from "./SearchDetailModal.vue?vue&type=template&id=15405569&scoped=true&"
import script from "./SearchDetailModal.vue?vue&type=script&lang=js&"
export * from "./SearchDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./SearchDetailModal.vue?vue&type=style&index=0&id=15405569&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15405569",
  null
  
)

export default component.exports